export enum siteRoutes {
  superAdminLogin = "/",
  adminLogin = "/users/login",
  forgetPassword = "/users/login/forget-password",
  codeVerification = "/users/login/verification-code",
  createOrganization = "/private/organization/organization-management/create",
  organizationListing = "/private/organization/organization-management/listing",
  viewOrganization = "/private/organization/organization-management/view",
  createAsset = "/private/infrastructure-and-assets/assets-management/create",
  assetsListing = "/private/infrastructure-and-assets/assets-management/listing",
  createBuilding = "/private/infrastructure-and-assets/buildings-management/create",
  buildingListing = "/private/infrastructure-and-assets/buildings-management/listing",
  createBuildingStructure = "/private/infrastructure-and-assets/buildings-structure/create",
  buildingStructureListing = "/private/infrastructure-and-assets/buildings-structure/listing",
  assetTypeListing = "/private/infrastructure-and-assets/asset-types/listing",
  createAssetType = "/private/infrastructure-and-assets/asset-types/create",
  roomTypeListing = "/private/infrastructure-and-assets/room-types/listing",
  createRoomType = "/private/infrastructure-and-assets/room-types/create",
  createProgram = "/private/academics/programs/create",
  programListing = "/private/academics/programs/listing",
  createOrgStructure = "/private/organization/organizational-structures/create",
  orgStructureListing = "/private/organization/organizational-structures/listing",
  createStructureType = "/private/organization/structure-types/create",
  structureTypeListing = "/private/organization/structure-types/listing",
  resultTypeListing = "/private/organization/result-types/listing",
  resultTypeCreate = "/private/organization/result-types/create",
  superAdminDashboard = "/private/dashboard/super-admin-dashboard",
  dsStudentDashboard = "/private/ds-system/student-dashboard",
  dsStudentAcademicDashboard = "/private/ds-system/student-academic-dashboard",
  academicsDeficientStudentsListing = "/private/academics/deficient-students/listing",
  smartpayDashboard = "/private/ds-system/smartpay-dashboard",
  admissionsSettingsOpenMigrations = "/private/admissions/settings/open-migrations",
  adminDashboard = "/private/dashboard/admin-dashboard",

  myProfileAdminList = "/private/my-apps/my-profile-show",
  myProfileAdminCreate = "/private/my-apps/my-profile-create",
  myProfileAdminAttendanceList = "/private/my-apps/my-attendance-list",
  myAppsInitiateLeave = "/private/my-apps/initiate-leave",
  myAppsAttendanceRequest = "/private/my-apps/attendance-request",
  myProfileAdminSalaryList = "/private/my-apps/my-salary-list",
  academicWeeklyReportsListing = "/private/my-apps/weekly-reports/listing",
  academicWeeklyReportsCreate = "/private/my-apps/weekly-reports/create",
  academicWeeklyReportsView = "/private/my-apps/weekly-reports/view",
  academicMonthlyReportsListing = "/private/my-apps/monthly-reports/listing",
  academicMonthlyReportsCreate = "/private/my-apps/monthly-reports/create",
  academicMonthlyReportsView = "/private/my-apps/monthly-reports/view",
  myAppsAcademicSessionListing = "/private/my-apps/academic-session/listing",
  myAppsCreateAcademicSession = "/private/my-apps/academic-session/create",
  myAppsMyCoursesListing = "/private/my-apps/my-courses/listing",
  myAppsMyReferrals = "/private/my-apps/my-referrals/listing",
  myAppsMyReferralsCreate = "/private/my-apps/my-referrals/create",
  procurementMaterialRequestListing = "/private/procurement/material-requests/listing",
  createProcurementMaterialRequest = "/private/procurement/material-requests/create",
  viewProcurementMaterialRequest = "/private/procurement/material-requests/view",
  procurementInbox = "/private/procurement/inbox",
  procurementRequisitionApprovalView = "/private/procurement/inbox/view/:id",

  // Elections Module
  electionsListing = "/private/student-affairs/elections/listing",
  createElection = "/private/student-affairs/elections/create",
  electionPositionsListing = "/private/student-affairs/election-positions/listing",
  createElectionPosition = "/private/student-affairs/election-positions/create",
  electionSymbolsListing = "/private/student-affairs/election-symbols/listing",
  createElectionSymbol = "/private/student-affairs/election-symbols/create",
  electionCandidatesListing = "/private/student-affairs/election-candidates/listing",
  createElectionCandidate = "/private/student-affairs/election-candidates/create",
  electionLiveResults = "/private/student-affairs/elections/results",
  studentElectionCenter = "/private/e-portal/elections/center",
  studentVotingBooth = "/private/e-portal/elections/voting-booth",
  studentSocietyApplicationsAdminListing = "/private/student-affairs/society-applications/listing",
  universityEventApplicantsListing = "/private/student-affairs/university-event-applicants/listing",

  // Budget Estimation
  budgetEstimationListing = "/private/finance/budget-estimation/listing",
  myBudgetEstimationListing = "/private/finance/budget-estimation/my-listing",
  allBudgetEstimationListing = "/private/finance/budget-estimation/all-listing",
  createBudgetEstimation = "/private/finance/budget-estimation/create",
  viewBudgetEstimation = "/private/finance/budget-estimation/view",

  ePortalLogin = "/e-portal/login",
  ePortalRegister = "/e-portal/register",
  ePortalResetPassword = "/e-portal/reset-password",
  ePortalDashboard = "/private/e-portal/e-portal-dashboard",
  ePortalEditProfile = "/private/e-portal/admission/edit-profile",
  ePortalEditProfileAddtionalInofrmation = "/private/e-portal/admission/edit-profile-additional-information",
  ePortalChallanListing = "/private/e-portal/challan-listing",
  ePortalMyVouchers = "/private/e-portal/my-vouchers",

  ePortalShortCoursesListing = "/private/e-portal/short-courses-listing",
  ePShortAppliedCoursesListing = "/private/e-portal/applied-short-courses-listing",

  eportalHostelPortal = "/private/e-portal/eportal-hostel-portal",
  eportalAdmissionsListing = "/private/e-portal/admission/applications",
  studentMigrationApplicationCreate = "/private/e-portal/migrations/apply",
  studentMigrationApplicationsListing = "/private/e-portal/migrations/applications",
  whatsappTemplateListing = "/private/organization/whatsapp-template/listing",
  whatsappTemplateCreate = "/private/organization/whatsapp-template/create",
  smsTemplateListing = "/private/organization/sms-template/listing",
  smsTemplateCreate = "/private/organization/sms-template/create",
  createEportalAdmissionList = "/private/e-portal/admission/apply",
  createHostel = "/private/hostel/hostel-management/create-hostel",
  hostelListing = "/private/hostel/hostel-management/hostel-listing",
  createHostelRoom = "/private/hostel/hostel-rooms-management/create-hostel-room",
  hostelRoomsListing = "/private/hostel/hostel-rooms-management/hostel-rooms-listing",
  applicantListing = "/private/hostel/applicants-management/applicant-listing",
  createApplicant = "/private/hostel/applicants-management/create-applicant",
  createHostelMerit = "/private/hostel/merit-management/create-merit",
  hostelMeritListing = "/private/hostel/merit-management/merit-listing",
  hostelSessionListing = "/private/hostel/session-management/hostel-session-listing",
  createHostelSession = "/private/hostel/session-management/create-hostel-session",
  hostelFinanceManagement = "/private/hostel/hostel-finance-management",
  appliedApplicant = "/private/hostel/applied-applicant",
  applicantEnrollment = "/private/hostel/applicant-enrollment",
  registeredApplicant = "/private/hostel/registered-applicant",
  hostelApplicantMeritList = "/private/hostel/hostel-applicant-merit-list",
  academicSessionListing = "/private/academics/academic-session-management/academic-session-listing",

  // academic batch
  academicBatchListing = "/private/academics/academic-batch-management/academic-batch-listing",
  createAcademicBatch = "/private/academics/academic-batch-management/create-academic-batch",

  // academic batch semester
  academicBatchSemesterListing = "/private/academics/academic-batch-semester/academic-batch-semester-listing",
  createAcademicBatchSemester = "/private/academics/academic-batch-semester/create-academic-batch-semester",

  // academic batch section

  createAdmissionSession = "/private/organization/admission-session/create",
  viewEportalProfile = "/private/e-portal/user-profile/view-profile",
  admissionSessionListing = "/private/organization/admission-session/listing",
  admissionCampaignListing = "/private/admissions/admission-campaigns/listing",
  createAdmissionCampaign = "/private/admissions/admission-campaigns/create",
  admissionCohortManagementListing = "/private/admissions/cohort-management/listing",
  admissionCohortManagementCreate = "/private/admissions/cohort-management/create",
  admissionCohortManagementProgramsListing = "/private/admissions/cohort-management-programs/listing",
  admissionCohortManagementProgramsCreate = "/private/admissions/cohort-management-programs/create",
  admissionCohortManagementCuttoffListing = "/private/admissions/cohort-management-cutt-off/listing",
  admissionCohortManagementCuttoffCreate = "/private/admissions/cohort-management-cutt-off/create",

  admissionCrmMetaLeadsListing = "/private/admissions/crm-meta-leads/listing",
  admissionCrmMetaLeadsCreate = "/private/admissions/crm-meta-leads/create",
  admissionCrmMetaLeadsEdit = "/private/admissions/crm-meta-leads/edit",
  admissionCrmMetaLeadsView = "/private/admissions/crm-meta-leads/view",
  admissionCrmMetaLeadsDelete = "/private/admissions/crm-meta-leads/delete",
  admissionCrmMetaLeadsShow = "/private/admissions/crm-meta-leads/show",

  outreachEventListing = "/private/admissions/outreach-events/listing",
  createOutreachEvent = "/private/admissions/outreach-events/create",
  outreachEventParticipantListing = "/private/admissions/outreach-event-participants/listing",
  createOutreachEventParticipant = "/private/admissions/outreach-event-participants/create",

  admissionAgenciesListing = "/private/admissions/agencies/listing",
  admissionAgenciesCreate = "/private/admissions/agencies/create",
  admissionAgenciesAgentsListing = "/private/admissions/agencies-agents/listing",
  admissionAgenciesAgentsCreate = "/private/admissions/agencies-agents/create",
  admissionAgenciesLinkedUserListing = "/private/admissions/agencies-linked-user/listing",
  admissionAgenciesLinkedUserCreate = "/private/admissions/agencies-linked-user/create",

  addmissionShortCoursesListing = "/private/admissions/short-courses/listing",
  addmissionShortCoursesCreate = "/private/admissions/short-courses/create",
  shortCourseTypesListing = "/private/admissions/short-course-types/listing",
  shortCourseTypesCreate = "/private/admissions/short-course-types/create",
  addmissionShortCoursesPollListing = "/private/admissions/short-courses-polls/listing",
  addmissionShortCoursesPollCreate = "/private/admissions/short-courses-polls/create",
  addmissionShortCoursesEnrollmentsListing = "/private/admissions/short-courses-enrollments/listing",
  addmissionShortCoursesApplicationsListing = "/private/admissions/short-courses-applications/listing",

  admissionStudentListing = "/private/admissions/admission-students-listing",
  admissionStudentProfile = "/private/admissions/admission-students-listing/profile/:student_id",
  admissionStudentMeritListing = "/private/admissions/students-merit-listing",
  loginAsStudentAdmissionApplication = "/private/admissions/",
  editStudentAdmissionApplication = "/private/admissions/",
  callStudentAdmissionApplication = "/private/admissions",
  messageStudentAdmissionApplication = "/private/admissions",
  admissionApplicantsListing = "/private/admissions/admission-applicants-listing",
  editAdmissionDocument = "/private/admissions/admission-documents-management/create",
  admissionDocumentListing = "/private/admissions/admission-documents-management/listing",
  admissionTestTypesListing = "/private/admissions/admission-test-types/listing",
  createAdmissionTestType = "/private/admissions/admission-test-types/create",
  studentRegListing = "/private/admissions/student-registration-listing",
  feeRefundListing = "/private/admissions/fee-refund-listing",
  orientationResponseListing = "/private/admissions/orientation-responses-listing",
  eportalOrientationResponse = "/private/e-portal/orientation-response",
  admissionMeritListing = "/private/admissions/admission-merit-listing",
  admissionOfferLetterListing = "/private/admissions/admission-offer-letter/listing",
  addmissionOfferLetterLinkProgramListing = "/private/admissions/admission-offer-letter-link-programs/listing",
  createAdmissionOfferLetter = "/private/admissions/admission-offer-letter/create",
  editAdmissionBoard = "/private/admissions/edit-admission-board",
  editAdmissionCertificate = "/private/admissions/edit-admission-certificate",
  admissionManageDocumentsMasterListing = "/private/admissions/admission-documents-master-listing",
  admissioneligibilityTemplateHeadersListing = "/private/admissions/admission-eligibility-templates/headers-listing",
  createAdmissioneligibilityTemplateHeaders = "/private/admissions/admission-eligibility-templates/create-header",
  admissioneligibilityTemplateBodiesListing = "/private/admissions/admission-eligibility-templates/bodies-listing",
  createAdmissioneligibilityTemplateBody = "/private/admissions/admission-eligibility-templates/create-body",
  admissionQuotasListing = "/private/admissions/admission-quotas/admission-quotas-listing",
  createAdmissionQuotas = "/private/admissions/admission-quotas/create-admission-quotas",

  // Access Templates Headers
  accessTemplatesHeadersListing = "/private/organization/access-templates-headers/listing",
  createAccessTemplatesHeaders = "/private/organization/access-templates-headers/create",

  // QMS Routes
  studentQmsDashboard = "/private/e-portal/qms/dashboard",
  studentQmsCreateQuery = "/private/e-portal/qms/create-query",
  studentQmsViewQuery = "/private/e-portal/qms/queries/:id",
  qmsDashboard = "/private/qms/staff/dashboard",
  qmsServicesListing = "/private/qms/staff/services/listing",
  qmsServicesCreate = "/private/qms/staff/services/create",
  qmsCategoriesListing = "/private/qms/staff/categories/listing",
  qmsCategoriesCreate = "/private/qms/staff/categories/create",
  qmsPrioritiesListing = "/private/qms/staff/priorities/listing",
  qmsPrioritiesCreate = "/private/qms/staff/priorities/create",
  qmsStatusesListing = "/private/qms/staff/statuses/listing",
  qmsStatusesCreate = "/private/qms/staff/statuses/create",
  qmsRequestTypesListing = "/private/qms/staff/request-types/listing",
  qmsRequestTypesCreate = "/private/qms/staff/request-types/create",
  qmsWorkflowsListing = "/private/qms/staff/workflows/listing",
  qmsWorkflowsCreate = "/private/qms/staff/workflows/create",
  qmsQueriesListing = "/private/qms/staff/queries/listing",
  qmsQueriesView = "/private/qms/staff/queries/view/:id",

  // Access Templates Body
  accessTemplatesBodyListing = "/private/organization/access-templates-body/listing",
  createAccessTemplatesBody = "/private/organization/access-templates-body/create",

  certificateLinkListing = "/private/organization/result-type/certificate-link-listing",
  certificateLinkCreate = "/private/organization/result-type/certificate-link-create",
  roleManagementListing = "/private/system-administration/admin-role-management/listing",
  rollManagementCreate = "/private/system-administration/admin-role-management/create",
  boardManagementListing = "/private/organization/board-management/board-management-listing",
  boardManagementCreate = "/private/organization/board-management/board-management-create",
  subjectManagementListing = "/private/admissions/subject-management/subject-management-listing",
  subjectManagementCreate = "/private/admissions/subject-management/subject-management-create",
  certificateManagementListing = "/private/organization/certificate-management/certificate-management-listing",
  certificateManagementCreate = "/private/organization/certificate-management/certificate-management-create",
  superAdminManagementListing = "/private/organization/super-admin-management/listing",
  superAdminManagementCreate = "/private/organization/super-admin-management/create",
  superRoleManagementListing = "/private/organization/super-role-management/listing",
  superRoleManagementCreate = "/private/organization/super-role-management/create",
  permissionManagementListing = "/private/organization/permission-management/listing",
  permissionManagementCreate = "/private/organization/permission-management/create",
  moduleManagement = "/private/organization/module-management",
  moduleManagementCreate = "/private/organization/module-management/create",
  moduleSettingsListing = "/private/organization/module-management/settings",
  linkedSpecializationListing = "/private/organization/programs/linked-specialization-listing",
  createLinkedSpecialization = "/private/organization/programs/create-linked-specialization",
  linkedProgramEntryTestListing = "/private/organization/programs/linked-program-entry-test-listing",
  createLinkedProgramEntryTest = "/private/organization/programs/create-linked-program-entry-test",
  academicSessionOrganizationListing = "/private/organization/academic-session-organization/academic-session-organization-listing",
  createAcademicSessionOrganization = "/private/organization/academic-session-organization/create-academic-session-organization",
  admissionProgramListing = "/private/admissions/admission-program/admission-program-listing",
  admissionSubjectManagementListing = "/private/admissions/admission-subject-mangement/admission-subject-management-listing",
  createAdmissionSubjectManagement = "/private/admissions/admission-subject-mangement/create-admission-subject-management",
  admissionBoardManagementListing = "/private/admissions/admission-board-management/admission-board-management-listing",
  createAdmissionBoardManagement = "/private/admissions/admission-board-management/create-admission-board-management",
  admissionCertificateManagementListing = "/private/admissions/certificate-management/listing",
  createAdmissionCertificateManagement = "/private/admissions/certificate-management/create",
  meritKeysListing = "/private/admissions/merit-keys/listing",
  createMeritKeys = "/private/admissions/merit-keys/create",
  entryTestListing = "/private/admissions/entry-test/listing",
  entryTestCreate = "/private/admissions/entry-test/create",
  adminMigrationApplications = "/private/admissions/migration-applications",
  meritListFormulaListing = "/private/admissions/merit-list-formulas/listing",
  createMeritListFormula = "/private/admissions/merit-list-formulas/create",
  // linkedProgramAdmissionListing = '/private/admission/linked-program-admission/linked-program-admission-listing',
  majorCategoriesListing = "/private/organization/assets-management/major-categories-listing",
  CreateMajorCategories = "/private/organization/assets-management/create-major-categories",
  minorCategoriesListing = "/private/organization/assets-management/minor-categories-listing",
  createMinorCategories = "/private/organization/assets-management/create-minor-categories",
  roomsListing = "/private/organization/buildings-management/rooms-listing",
  createRooms = "/private/organization/buildings-management/create-rooms",
  quotasAdmissionListing = "/private/admissions/quota-management/listing",
  createQuotasAdmissionList = "/private/admissions/quota-management/create",
  admissionEducationFlowListing = "/private/admissions/admission-education-flow/listing",
  createAdmissionEducationFlow = "/private/admissions/admission-education-flow/create",
  manageMeritListListing = "/private/admissions/manage-merit-list/listing",
  createAdmissionManageMeritList = "/private/admissions/manage-merit-list/create",
  qoutasListProgramListing = "/private/admissions/qoutas-list-management/quota-list-program-listing",
  eligibilityTemplatesListing = "/private/admissions/admission-campaigns/program-link-template-listing",
  eligibilityTemplatesCreate = "/private/admissions/admission-campaigns/create-program-link-template",
  programLinkMeritList = "/private/admissions/admission-campaigns/program-link-merit-listing",
  programLinkQuotaList = "/private/admissions/admission-campaigns/program-link-quota",
  createProgramLinkMeritList = "/private/admissions/admission-campaigns/create-program-link-merit",
  feeIncomeDashboard = "/private/ds-system/fee-income-dashboard",
  financeOnlineDashboard = "/private/ds-system/finance-online-dashboard",
  resportsListing = "/private/ds-system/reports-listing",
  academicReportsListing = "/private/ds-system/academic-reports-listing",
  reportsDashboard = "/private/ds-system/reports-dashboard",
  resportsCreate = "/private/ds-system/reports-create",
  reportPreview = "/private/ds-system/report-preview",
  systemUsersListing = "/private/system-administration/system-users/system-users-listing",
  permissionsListing = "/private/system-administration/permissions/listing",
  createSystemUsers = "/private/system-administration/system-users/create-system-users",
  referralsListing = "/private/system-administration/users/referrals",
  createReferral = "/private/system-administration/users/referrals/create",
  systemMenusListing = "/private/system-administration/menus/system-menus-listing",
  organizationSettingCreate = "/private/system-administration/organization-setting/create",
  lmsSyncAudit = "/private/system-administration/lms-sync",
  createSystemMenus = "/private/system-administration/menus/create-system-menus",
  unregisteredMenusListing = "/private/system-administration/unregistered-menus-listing",
  userAuditListing = "/private/system-administration/user-audit-listing",
  workflowListing = "/private/system-administration/workflow/workflow-listing",
  createWorkflow = "/private/system-administration/workflow/create-workflow",
  editWorkflow = "/private/system-administration/workflow/edit-workflow/:id",
  workflowApprovalInbox = "/private/system-administration/workflow/approval-inbox",
  workflowApprovalHistory = "/private/system-administration/workflow/approval-history",
  workflowApprovalView = "/private/system-administration/workflow/approval-inbox/view/:id",
  workflowBoundaryRulesListing = "/private/system-administration/workflow/boundary-rules-listing",
  // Minute Sheets
  minuteSheetListing = "/private/minute-sheets/listing",
  minuteSheetAllListing = "/private/minute-sheets/all-listing",
  minuteSheetTrackingListing = "/private/minute-sheets/tracking",
  minuteSheetInbox = "/private/minute-sheets/inbox",
  minuteSheetOutbox = "/private/minute-sheets/outbox",
  minuteSheetInitiate = "/private/minute-sheets/initiate",
  minuteSheetView = "/private/minute-sheets/view/:id",
  minuteSheetSeriesListing = "/private/minute-sheets/series/listing",
  minuteSheetSeriesCreate = "/private/minute-sheets/series/create",

  // Single Interface Request (SIR)
  sirMyRequestsListing = "/private/sir/requests/listing",
  sirCreateRequest = "/private/sir/requests/create",
  sirServiceInbox = "/private/sir/requests/inbox",
  sirViewRequest = "/private/sir/requests/view/:id",

  eportalCareersListing = "/private/e-portal/e-portal-career/eportal-career-listing",
  createEportalCareer = "/private/e-portal/e-portal-career/create-eportal-career",
  systemLogsListing = "/private/system-administration/system-logs-listing",
  studentFinancialClearanceListing = "/private/finance/student-financial-clearance-listing",
  checkFinancialChallanStatus = "/private/finance/check-financial-challan-status",
  fineSlotsListing = "/private/finance/fine-slots/fine-slots-listing",
  createFineSlot = "/private/finance/fine-slots/create-fine-slot",
  createProgramCategoryTypes = "/private/academics/program-category-types/create",
  programCategoryTypesListing = "/private/academics/program-category-types/listing",
  templateProgramAccountCodeListing = "/private/finance/template-program-account-code-listing",
  voucherTypesListing = "/private/finance/voucher-types/voucher-types-listing",
  createVoucherType = "/private/finance/voucher-types/create-voucher-type",
  createFinanceApplications = "/private/finance/finance-applications/create-finance-application",
  financeApplicationsListing = "/private/finance/finance-applications/finance-applications-listing",
  applicationTemplateLinkListing = "/private/finance/application-template-link/application-template-link-listing",
  createApplicationTemplateLink = "/private/finance/application-template-link/create-application-template-link",
  createVoucherTemplateHeader = "/private/finance/voucher-template-header/create-voucher-template-header",
  voucherTemplateHeaderListing = "/private/finance/voucher-template-header/voucher-template-header-listing",
  systemDesignAndReviewListing = "/private/system-administration/system-design-and-review/listing",
  systemDesignAndReviewCreate = "/private/system-administration/system-design-and-review/create",
  eportalRegistrationSettingsListing = "/private/system-administration/eportal-registration-settings/listing",
  eportalRegistrationSettingsCreate = "/private/system-administration/eportal-registration-settings/create",

  manualVouchersListing = "/private/finance/voucher-template-header/manual-vouchers-listing",
  manualVouchersCreate = "/private/finance/voucher-template-header/manual-vouchers-create",

  createBank = "/private/finance/banks/create-bank",
  banksListing = "/private/finance/banks/banks-listing",
  organizationPaymentsSettingCreate = "/private/finance/banks/banks-payments-setting-create",
  organizationPaymentsSettingListing = "/private/finance/banks/banks-payments-setting",
  bankTransactionLogsListing = "/private/finance/bank-transactions-logs-listing",
  bankScrollLogsListing = "/private/finance/bank-scroll-logs-listing",
  exchangeRatesListing = "/private/finance/exchange-rates-listing",
  studentWalletsListing = "/private/finance/student-wallets-listing",
  createExchangeRate = "/private/finance/exchange-rates/create",
  createVoucherParticular = "/private/finance/voucher-particulars/create-voucher-particular",
  voucherParticularListing = "/private/finance/voucher-particulars/voucher-particulars-listing",
  masterBookListing = "/private/finance/master-book/master-book-listing",
  masterBookListingTrash = "/private/finance/master-book/trash",
  masterBookUploadUpdate = "/private/finance/master-book/upload",
  masterBookTransactionDetail = "/private/finance/master-book/master-book-transaction-detail",
  showMasterBookTransactionDetail = "/private/finance/master-book/show-master-book-transaction-detail",
  eportalAppliedJobListing = "/private/e-portal/e-portal-career/eportal-applied-jobs-listing",
  eportalCarrerProfile = "/private/e-portal/e-portal-career/career-profile-listing",
  careerDesignationListing = "/private/career/designation-management/career-designation-listing",
  createCareerDesignation = "/private/career/designation-management/create-career-designation",
  careerAdvertisementListing = "/private/career/advertisement-management/career-advertisement-listing",
  createCareerAdvertisement = "/private/career/advertisement-management/create-career-advertisement",
  careerPostTemplateListing = "/private/career/post-template-management/post-template-listing",
  createCareerPostTemplate = "/private/career/post-template-management/create-post-template",
  expirienceCriteriaListing = "/private/career/post-template-management/post-template-experience-criteria-listing",
  expirienceCriteriaCreate = "/private/career/post-template-management/post-template-experience-criteria-create",
  careerPostListing = "/private/career/post-management/career-post-listing",
  createCareerPost = "/private/career/post-management/create-career-post",

  // scholarship module routes
  scholarshipListing = "/private/scholarship/scholarships/listing",
  scholarshipCreate = "/private/scholarship/scholarships/create",
  scholarShipPhasesListing = "/private/scholarship/scholarship-phases/listing",
  scholarShipPhasesCreate = "/private/scholarship/scholarship-phases/create",
  scholarShipTypesListing = "/private/scholarship/scholarship-type/listing",
  scholarShipTypesCreate = "/private/scholarship/scholarship-type/create",
  scholarShipOrganizationListing = "/private/scholarship/scholarship-organization/listing",
  scholarShipOrganizationCreate = "/private/scholarship/scholarship-organization/create",
  scholarShipAmountTypeListing = "/private/scholarship/scholarship-amount-type/listing",
  scholarShipAmountTypeCreate = "/private/scholarship/scholarship-amount-type/create",
  scholarShipStatusListing = "/private/scholarship/scholarship-status/listing",
  scholarShipStatusCreate = "/private/scholarship/scholarship-status/create",
  scholarshipScrutinyCommitteeListing = "/private/scholarship/scholarship-scrutiny-committee/listing",
  scholarshipScrutinyCommitteeCreate = "/private/scholarship/scholarship-scrutiny-committee/create",
  scholarshipApplicationsListing = "/private/scholarship/scholarship-applications/listing",
  scholarshipApplicationsCreate = "/private/scholarship/scholarship-applications/create",
  scholarshipApplicationsEdit = "/private/scholarship/scholarship-applications/edit",
  scholarshipApplicationsView = "/private/scholarship/scholarship-applications/view",
  scholarshipScrutinyListing = "/private/scholarship/scholarship-scrutiny/listing",
  scholarshipScrutinyCreate = "/private/scholarship/scholarship-scrutiny/create",
  scholarshipGrantListing = "/private/scholarship/scholarship-grant/listing",
  scholarshipGrantCreate = "/private/scholarship/scholarship-grant/create",
  scholarshipPaymentListing = "/private/scholarship/scholarship-payment/listing",
  scholarshipPaymentCreate = "/private/scholarship/scholarship-payment/create",
  scholarshipCommitteeDecisions = "/private/scholarship/committee-decisions/listing",

  careerApplicantListing = "/private/career/career-applicantions-listing",
  applicantsCandidateProfile = "/private/career/career-applicant-candidate/profile",
  careersApplicantsDetails = "/private/career/career-applicant-candidate/details",
  updateEportalCareerApplication = "/private/career/career-applicant-candidate/edit-career",
  careersViewDocuments = "/private/career/career-applicant/view-documents",

  voucherTemplateBodiesListing = "/private/finance/voucher-template-bodies/voucher-template-bodies-listing",
  financeInstallmentListing = "/private/finance/installment-management/installment-listing",
  createFinanceInstallment = "/private/finance/installment-management/create-installment",
  installmentSlotListing = "/private/finance/installment-slot-management/installment-slot-listing",
  createInstallmentSlot = "/private/finance/installment-slot-management/create-installment-slot",
  slotsInstallmentParticulars = "/private/finance/installment-slot-management/slots-installment-particulars",
  certificateLevelList = "/private/organization/certificate-level-management/listing",
  createCertificateLevels = "/private/organization/certificate-level-management/create",
  authoritiesListing = "/private/authorities-and-communities/authorities/listing",
  viewMembers = "/private/authorities-and-communities/authorities-member-listing",
  createAuthorities = "/private/authorities-and-communities/authorities/create",
  viewDocuments = "/private/authorities-and-communities/view-documents",
  senateMeetingList = "/private/authorities-and-communities/authorities/senate-meeting-listing",
  createSenateMeeting = "/private/authorities-and-communities/authorities/create-senate-meeting",
  councilNotificationsListing = "/private/authorities-and-communities/council-notification/council-notifications-listing",
  createCouncilNotifications = "/private/authorities-and-communities/council-notification/create-council-notifications",
  authorityMemberTypeListing = "/private/authorities-and-communities/authority-member-type/authority-member-type-listing",
  createAuthorityMemberType = "/private/authorities-and-communities/authority-member-type/create-authority-member-type",
  authorityTypeListing = "/private/authorities-and-communities/authority-type/authority-type-listing",
  createAuthorityType = "/private/authorities-and-communities/authority-type/create-authority-type",
  testingServicesDashboard = "/private/ds-system/testing-services-dashboard",
  testTypesListing = "/private/testing-services/test-types-management/test-types-listing",
  createTestType = "/private/testing-services/test-types-management/create-test-types",
  TestingServicesTestCenterlist = "/private/testing-services/test-center-management/test-center-listing",
  TestingServicesTestCentercreate = "/private/testing-services/test-center-management/create-test-center",
  TestingServicesTestSchedulelist = "/private/testing-services/test-schedule-management/test-schedule-listing",
  createTestingServicesTestSchedule = "/private/testing-services/test-schedule-management/create-test-schedule",
  testingServicespublishresult = "/private/testing-services/test-result-management/test-publish-result-listing",
  testingServicescandidateTestResultlist = "/private/testing-services/test-upload-result-management/test-upload-result-listing",
  testingCenterRooms = "/private/testing-services/test-center-rooms/test-center-rooms-listing",
  createTestingServicesTestCenterRooms = "/private/testing-services/test-center-rooms/create-test-center-rooms",
  testingServicesTestScheduleSeatingPlanlist = "/private/testing-services/test-schedule-management/seating-plan-listing",
  testingServicesTestScheduleSeatingPlanRoomslist = "/private/testing-services/test-schedule-management/seating-plan-room-listing",
  viewTestApplicants = "/private/testing-services/test-schedule-management/view-test-applicants",
  testingServicescandidatelisting = "/private/testing-services/candidate-applied-listing",
  reportCategoriesList = "/private/qec/report-categories/report-categories-listing",
  createreportCategories = "/private/qec/report-categories/create-report-categories",
  qecReportManagelist = "/private/qec/report-manage/report-manage-listing",
  createQecReportManage = "/private/qec/report-manage/create-report-manage",
  qecSurveyReportlist = "/private/qec/report-management/survey-report-listing",
  createQecSurveyReport = "/private/qec/report-management/create-survey-report",
  //survey batches management
  qecSurveyBatchlist = "/private/qec/batch-management/survey-batch-listing",
  createQecSurveyBatch = "/private/qec/batch-management/create-survey-batch",

  //survey semester management
  qecSurveySemesterlist = "/private/qec/semester-management/survey-semester-listing",
  createQecSurveySemester = "/private/qec/semester-management/create-survey-semester",

  //survey terms managment
  qecSurveyTermlist = "/private/qec/term-management/survey-term-listing",
  createQecSurveyTerm = "/private/qec/term-management/create-survey-term",

  surveyListing = "/private/qec/survey-management/survey-listing",
  courseEvaluation = "/private/qec/course-evaluation/listing",
  surveyParticipantsListing = "/private/qec/survey-management/survey-participants-listing",
  surveyAssignmentsListing = "/private/qec/survey-management/survey-assignments-listing",
  qecSurveyDashboard = "/private/ds-system/survey-dashboard",
  surveyProgramWiseReport = "/private/ds-system/survey-program-wise-report",
  createSurvey = "/private/qec/survey-management/create-survey",
  surveyTypeListing = "/private/qec/survey-type-management/survey-type-listing",
  createSurveyType = "/private/qec/survey-type-management/create-survey-type",
  questionListing = "/private/qec/question-management/question-listing",
  createQuestion = "/private/qec/question-management/create-question",
  libraryPublisherlist = "/private/library/publisher-management/library-publisher-listing",
  createLibraryPublisher = "/private/library/publisher-management/create-library-publisher",
  librarySellerlist = "/private/library/seller-management/library-seller-listing",
  createLibrarySeller = "/private/library/seller-management/create-library-seller",
  libraryBillslist = "/private/library/bill-management/library-bill-listing",
  createLibraryBills = "/private/library/bill-management/create-library-bill",
  libraryBookslist = "/private/library/books-management/library-books-listing",
  createLibraryBooks = "/private/library/books-management/create-library-books",
  libraryLanguagelist = "/private/library/language-management/language-listing",
  createLibraryLanguage = "/private/library/language-management/create-language",
  libraryAccessRegisterlist = "/private/library/library-access-management/library-access-register-listing",
  legalFrameworkList = "/private/legal-matter/legal-framework-management/legal-framework-listing",
  createLegalFramework = "/private/legal-matter/legal-framework-management/create-legal-framework",
  legalOrganizationList = "/private/legal-matter/legal-organization-management/legal-organization-listing",
  createLegalOrganization = "/private/legal-matter/legal-organization-management/create-legal-organization",
  frameworkDocumentTypeList = "/private/legal-matter/framework-document-type-management/framework-document-type-listing",
  createFrameworkDocumentType = "/private/legal-matter/framework-document-type-management/create-framework-document-type",
  billRequestList = "/private/legal-matter/bill-request-management/bill-request-listing",
  createBillRequest = "/private/legal-matter/bill-request-management/create-bill-request",
  legalCasesList = "/private/legal-matter/legal-cases-management/legal-cases-listing",
  createLegalCases = "/private/legal-matter/legal-cases-management/create-legal-cases",
  legalAdvisorListing = "/private/legal-matter/legal-advisor-management/legal-advisor-listing",
  createLegalAdvisor = "/private/legal-matter/legal-advisor-management/create-legal-advisor",
  legalCourtList = "/private/legal-matter/legal-court-management/legal-court-listing",
  createLegalCourt = "/private/legal-matter/legal-court-management/create-legal-court",
  shortCoursesDashboard = "/private/ds-system/shortcourses-dashboard",

  legalStatusList = "/private/legal-matter/legal-status-management/legal-status-listing",
  createLegalStatus = "/private/legal-matter/legal-status-management/create-legal-status",
  legalMatterTypeListing = "/private/legal-matter/legal-matter-type-management/legal-matter-type-listing",
  createLegalMatterType = "/private/legal-matter/legal-matter-type-management/create-legal-matter-type",
  advisorRatesListing = "/private/legal-matter/advisor-rates-management/advisor-rates-listing",
  createAdvisorRates = "/private/legal-matter/advisor-rates-management/create-advisor-rates",

  studentCardManagementListing = "/private/academics/student-card-management/listing",
  studentCardManagementCreate = "/private/academics/student-card-management/create",
  studentCardManagementTemplate = "/private/academics/student-card-management/template",
  studentsAdmitCardsListing = "/private/academics/students-admit-cards/listing",
  studentDuplicateCardManagementListing = "/private/academics/student-duplicate-card-management/listing",
  allocateCourseRoomListing = "/private/academics/common-courses-rooms/allocate-course-rooms-listing",
  academicGradeBookListing = "/private/academics/academic-session-management/grade-books-listing",
  academicGradeBookDetailsListing = "/private/academics/academic-session-management/grade-books-details-listing",
  createAcademicCourse = "/private/academics/academic-session-management/create-academic-course",
  academicsAttendancePolicy = "/private/academics/academic-session-management/attendance-policy",
  academicCourseListing = "/private/academics/academic-session-management/academic-courses-listing",
  createAcademicCourseGroup = "/private/academics/academic-session-management/create-course-group",
  academicCourseGroupListing = "/private/academics/academic-session-management/course-groups-listing",
  manageAcademicCourseGroup = "/private/academics/academic-session-management/manage-course-group",
  academicsCourseMaterialListing = "/private/academics/academic-session-management/course-groups-listing",
  academicsCourseMaterialCreate = "/private/academics/academic-session-management/course-groups-listing",
  academicSessionManagementListing = "/private/academics/academic-session-management/session-management-listing",
  academicMarksManagement = "/private/academics/academic-session-management/marks-management",
  announceResultListing = "/private/academics/academic-session-management/announce-result",
  graduateStudentsListing = "/private/academics/academic-session-management/graduate-students",
  compiledResultView = "/private/academics/academic-session-management/compiled-result-view",
  academicSessionManagementListingNew = "/private/academics/academic-session-management/session-management-listing-new",
  academicCalenderListing = "/private/academics/academic-session-management/academic-calender-listing",
  academicCalenderCreate = "/private/academics/academic-session-management/academic-calender-create",
  fGradeStudentsReport = "/private/academics/academic-session-management/f-grade-students-report",

  academicsCourseMaterialList = "/private/academics/academic-session-management/course-material-listing",
  academicsCourseMaterialUpload = "/private/academics/academic-session-management/course-material-upload",

  academicEnrollmentsListing = "/private/academics/academic-enrollments/academic-enrollments-listing",
  createCommonCoursesPools = "/private/academics/common-courses-pools/create-common-courses-pool",
  commonCoursesPoolsListing = "/private/academics/common-courses-pools/common-courses-pools-listing",
  academicStudent = "/private/academics/academic-student/student-listing",
  academicStudentCreate = "/private/academics/academic-student/create",
  academicStudentEdit = "/private/academics/academic-student/edit",
  academicStudentViewProfile = "/private/academics/academic-student/view-profile",
  academicStudentFine = "/private/academics/academic-student-fine/student-fine-listing",
  approvedReceiptAcknowledgedListing = "/private/academics/approved-receipt-acknowledged/approved-receipt-acknowledged-listing",
  receiptAcknowledgedListing = "/private/academics/receipt-acknowledged/receipt-acknowledged-listing",
  appRecAckViewAwardList = "/private/academics/receipt-acknowledged/view-award-list",
  verifyViewAwardList = "/private/my-apps/exam-incharge-courses/view-award-list",
  appRecAppViewAwardList = "/private/academics/approved-receipt-acknowledged/view-award-list",
  oricDashboard = "/private/oric/oric-dashboard",
  oricEventTypesListing = "/private/oric/oric-events/event-type-listing",
  createOricEventTypes = "/private/oric/oric-events/create-event-type",
  oricConferenceListing = "/private/oric/oric-conference/oric-conference-listing",
  createOricConference = "/private/oric/oric-conference/create-oric-conference",
  oricCallListing = "/private/oric/oric-calls/oric-calls-listing",
  createOricCalls = "/private/oric/oric-calls/create-oric-call",
  oricCallCategoriesListing = "/private/oric/oric-calls-category/oric-call-category-listing",
  createOricCallCategories = "/private/oric/oric-calls-category/create-oric-call-category",
  oricCareerDevelopmentListing = "/private/oric/oric-career-development/career-development-listong",
  keyPerformanceIndicatorYearListing = "/private/oric/oric-performance-indicator/key-performance-indicator-year-listing",
  createKeyPerformanceIndicatorYear = "/private/oric/oric-performance-indicator/create-key-performance-indicator-year",
  researchIncentivesListing = "/private/oric/oric-research-incentives/research-incentives-listing",
  createResearchIncentives = "/private/oric/oric-research-incentives/create-research-incentives",
  oricCommunityListing = "/private/oric/oric-community/oric-communities-listing",
  publicationRewardsListing = "/private/oric/publication-rewards/listing",
  createPublicationReward = "/private/oric/publication-rewards/create",
  publicationRewardTracking = "/private/oric/publication-rewards/tracking/:id",
  createOricCommunity = "/private/oric/oric-community/create-oric-communities",
  oricMouPartyListing = "/private/oric/oric-mou-party/oric-mou-party-listing",
  createOricMouParty = "/private/oric/oric-mou-party/create-oric-mou-party",
  oricMouListing = "/private/oric/oric-mou/oric-mou-listing",
  // Trigger rebuild comment
  createOricMou = "/private/oric/oric-mou/create-oric-mou",
  oricProjectDateListing = "/private/oric/oric-project/oric-project-date-listing",
  createOricProjectDate = "/private/oric/oric-project/create-oric-project-date",
  oricProjectlisting = "/private/oric/oric-project-management/oric-project-listing",
  createOricProject = "/private/oric/oric-project-management/create-oric-project",
  oricResearchGrantApplicationslisting = "/private/oric/oric-research-application/oric-research-application-listing",
  oricResearchProjectListing = "/private/oric/oric-research-project/oric-research-project-listing",
  createOricResearchProject = "/private/oric/oric-research-project/create-oric-research-project",
  oricMajorSubjectsListing = "/private/oric/oric-major-subject/oric-major-subjects-listing",
  createOricMajorSubjects = "/private/oric/oric-major-subject/create-oric-major-subjects",
  oricKPIScore = "/private/oric/oric-kpi-score/oric-kpi-score-listing",

  poolTeachersListing = "/private/academics/common-courses-pools/pool-teachers-listing",
  enrollPoolTeacher = "/private/academics/common-courses-pools/enroll-pool-teacher",
  consolidatedResultsListing = "/private/academics/consolidated-results/listing",
  sectionCoursesListing = "/private/academics/consolidated-results-section-courses-listing",
  submittedCoursesListing = "/private/academics/consolidated-results/submitted-courses-listing",
  financeAcademicSessionListing = "/private/academics/finance-academic-session/listing",
  semesterFeeVoucherListing = "/private/academics/financial-fee/vouchers",
  createFinanceAcademicSession = "/private/academics/finance-academic-session/create",
  financeSessionStudentsListing = "/private/academics/finance-academic-session/finance-session-students",
  academicDefaulterStudent = "/private/academics/academic-defaulter-student/academic-defaulter-student-listing",
  academicFeeTypeListing = "/private/academics/academic-fee-type/academic-fee-type-listing",
  createAcademicFeeType = "/private/academics/academic-fee-type/create-academic-fee-type",
  academicStudentClearence = "/private/academics/academic-student-clearence",
  manageGradeTemplates = "/private/academics/manage-grade-templates",
  createAcademicTemplateCourse = "/private/academics/template-courses/create",
  academicTemplateCoursesListing = "/private/academics/template-courses/listing",
  academicTemplateCourseMaterialListing = "/private/academics/template-course-material/listing",
  academicTemplateCourseMaterialCreate = "/private/academics/template-course-material/create",
  academicVirtualCoursesListing = "/private/academics/template-courses/manage-virtual-courses",
  obePeosListing = "/private/academics/obe-framework/peos/listing",
  obePeosCreate = "/private/academics/obe-framework/peos/create",
  obePlosListing = "/private/academics/obe-framework/plos/listing",
  obePlosCreate = "/private/academics/obe-framework/plos/create",
  obeKnowledgeProfilesListing = "/private/academics/obe-framework/knowledge-profiles/listing",
  obeKnowledgeProfilesCreate = "/private/academics/obe-framework/knowledge-profiles/create",
  obeKnowledgeProfilesEdit = "/private/academics/obe-framework/knowledge-profiles/edit/:id",
  obeEngineeringCompetenciesListing = "/private/academics/obe-framework/engineering-competencies/listing",
  obeEngineeringCompetenciesCreate = "/private/academics/obe-framework/engineering-competencies/create",
  obeEngineeringCompetenciesEdit = "/private/academics/obe-framework/engineering-competencies/edit/:id",
  obeClosListing = "/private/academics/obe-framework/clos/listing",
  obeClosCreate = "/private/academics/obe-framework/clos/create",
  obePeoPloMappingListing = "/private/academics/obe-framework/obe-mapping/peo-plo/listing",
  obePloCloMappingListing = "/private/academics/obe-framework/obe-mapping/plo-clo/listing",
  obeAttainmentDashboard = "/private/academics/obe-framework/attainment-dashboard",
  academicTemplateCoursesCoReqListing = "/private/academics/template-course-co-req/listing",
  academicTemplateCoursesPreReqListing = "/private/academics/template-course-pre-req/listing",
  academicTemplateEqualentCourseList = "/private/academics/manage-equivalent-courses/listing",
  createAcademicInternship = "/private/academics/academic-internships/create",
  academicInternshipsListing = "/private/academics/academic-internships/listing",
  createAcademicFeePlan = "/private/academics/academic-fee-plan/create",
  academicFeePlansListing = "/private/academics/academic-fee-plan/listing",
  createAcademicFeeQuota = "/private/academics/academic-fee-quota/create",
  academicFeeQuotasListing = "/private/academics/academic-fee-quota/listing",
  academicManageFeePlanListing = "/private/academics/academic-session-management/manage-fee-plan-listing",
  academicFeeTransactionsListing = "/private/academics/fee-transactions/listing",
  createAcademicFeeReceipt = "/private/academics/fee-transactions/create-fee-receipt",
  academicPaidVouchersListing = "/private/academics/academic-paid-vouchers-listing",
  academicExamTypeListing = "/private/academics/academic-exam-types/listing",
  createAcademicExamType = "/private/academics/academic-exam-types/create",
  basarStudentRequestsListing = "/private/academics/basar-requests/listing",
  academicCourseRepeatWorkflowListing = "/private/academics/course-repeat-workflow/listing",
  academicsStudentMigrationListing = "/private/academics/student-migration-workflow/listing",
  academicsStudentMigrationCreate = "/private/academics/student-migration-workflow/create",
  basarSupervisorsListing = "/private/academics/basar-supervisors/listing",
  basarSupervisorsCreate = "/private/academics/basar-supervisors/create",
  basarSupervisorProgramsListing =
    "/private/academics/basar-supervisors/programs/listing",

  examInchargePrograms = "/private/my-apps/exam-incharge-programs/listing",
  examInchargeSections = "/private/my-apps/exam-incharge-section/listing",
  examInchargeCourses = "/private/my-apps/exam-incharge-courses/listing",
  programAdvisorPrograms = "/private/my-apps/advisor-programs/listing",
  programAdvisorEnrollmentListing = "/private/my-apps/advisor-programs/enrollment-list",

  createAcademicExam = "/private/academics/academic-exams/create",
  academicExamsListing = "/private/academics/academic-exams/listing",
  createAcademicInvigilator = "/private/academics/invigilators/create",
  academicInvigilatorsListing = "/private/academics/invigilators/listing",

  academicExamInvigilatorsListing = "/private/academics/exam-invigilators/listing",
  academicExamInvigilatorsCreate = "/private/academics/exam-invigilators/create",
  academicExamRoomsListing = "/private/academics/exam-rooms/listing",
  academicExamRoomsCreate = "/private/academics/exam-rooms/create",
  academicExamProgramsListing = "/private/academics/exam-programs/listing",
  academicExamProgramsCreate = "/private/academics/exam-programs/create",
  academicExamDaySlotsListing = "/private/academics/exam-day-slots/listing",
  academicExamDaySlotsCreate = "/private/academics/exam-day-slots/create",
  academicExamTimeSlotsListing = "/private/academics/exam-time-slots/listing",
  academicExamTimeSlotsCreate = "/private/academics/exam-time-slots/create",
  academicExamTimeSlotsRoomsAllocationListing = "/private/academics/exam-time-slots-rooms-allocation/listing",
  academicExamTimeSlotsRoomsAllocationCreate = "/private/academics/exam-time-slots-rooms-allocation/create",
  academicTimeSlotsListing = "/private/academics/time-slots/listing",
  academicTimeSlotsCreate = "/private/academics/time-slots/create",
  academicExamsResultListing = "/private/academics/exams-result/listing",
  academicExamsResultCreate = "/private/academics/exams-result/create",
  academicExamsResultsSkippedListing = "/private/academics/exams-result-skipped/listing",

  createAcademicAuthority = "/private/academics/authorities/create",
  academicAuthorityListing = "/private/academics/authorities/listing",
  createAcademicAuthorityUser = "/private/academics/authorities/create-authority-user",
  academicAuthorityUsersListing = "/private/academics/authorities/authority-users-listing",
  createAcademicGradeTemplate = "/private/academics/grade-templates/create",
  academicGradeTemplatesListing = "/private/academics/grade-templates/listing",
  createAcademicStatus = "/private/academics/academic-status/create",
  academicStatusListing = "/private/academics/academic-status/listing",
  createClearanceAuthority = "/private/academics/clearance-authorities/create",
  clearanceAuthoritiesListing = "/private/academics/clearance-authorities/listing",
  createStudentStatus = "/private/academics/student-status/create",
  studentStatusListing = "/private/academics/student-status/listing",
  createStudentGroup = "/private/academics/student-groups/create",
  studentGroupListing = "/private/academics/student-groups/listing",
  createStudentSpecialization = "/private/academics/student-specializations/create",
  studentSpecializationsListing = "/private/academics/student-specializations/listing",
  createAcademicSemesterType = "/private/academics/semester-types/create",
  academicSemesterTypesListing = "/private/academics/semester-types/listing",
  createAcademicLetterGrade = "/private/academics/academic-letter-grades/create",
  academicLetterGradesListing = "/private/academics/academic-letter-grades/listing",
  createAcademicSection = "/private/academics/academic-section/create",
  academicSectionsListing = "/private/academics/academic-section/listing",
  academicSectionRoomsListing = "/private/academics/academic-section/rooms",
  academicManageExamIncharge = "/private/academics/manage-exam-incharge/manage-exam-incharge-listing",
  academicExamIncharge = "/private/academics/manage-exam-incharge/exam-incharge-listing",
  academicSyncGradeTemplates = "/private/academics/grade-templates/sync-grade-templates",
  studentClearenceListing = "/private/academics/student-clearence/student-clearence-listing",
  hrManagementLeaveDashboard = "/private/hr-management/leaves-dashboard",
  createOvertimeSlot = "/private/hr-management/overtime-slots/create",
  overtimeSlotsListing = "/private/hr-management/overtime-slots/listing",
  absentEmployeesListing = "/private/hr-management/absent-employees-listing",
  leaveCancellationListing = "/private/hr-management/leave-cancellation-listing",
  releasedLeaveBalancingReportListing = "/private/hr-management/released-leave-balancing-report-listing",
  remunerationListing = "/private/hr-management/remuneration-listing",
  overtimeManualEntryListing = "/private/hr-management/overtime-manual-entry-listing",
  employeesOvertimeListing = "/private/hr-management/employees-overtime-listing",
  teachersListing = "/private/hr-management/teachers/listing",
  teachersCreate = "/private/hr-management/teachers/create",
  employeesListing = "/private/hr-management/employees/listing",
  employeesCreate = "/private/hr-management/employees/create",
  gradeBookList = "/private/academics/grade-book/listing",

  employeesMetaListing = "/private/hr-management/employees-meta/listing",
  employeesMetaCreate = "/private/hr-management/employees-meta/create",

  requestedLeavesListing = "/private/hr-management/requested-leaves-listing",
  employeesAttendanceListing = "/private/hr-management/employees-attendance-list",
  employeesSalaryListing = "/private/hr-management/employees-salary-list",
  createLeaveRequestion = "/private/hr-management/leave-requestion",
  leaveTypeListing = "/private/hr-management/leave-type/leave-type-listing",
  createLeaveTypes = "/private/hr-management/leave-type/create-leave-type",
  setOffDays = "/private/hr-management/set-off-days",
  requestDetails = "/private/hr-management/request-details",
  academicPlanofStudies = "/private/academics/plan-of-studies/plan-of-studies-listing",
  createStudyPlans = "/private/academics/plan-of-studies/create-plan-of-studies",
  createAcademicSession = "/private/academics/academic-session-management/create-academic-session",
  planOfStudyCourseListing = "/private/academics/plan-of-studies/course-listing",
  planOfStudyCourseListingOld = "/private/academics/plan-of-studies/course-listing-old",
  planOfStudyStudentListing = "/private/academics/plan-of-studies/student-listing",
  createAuthorityBoard = "/private/authorities-and-communities/authority-boards/create",
  authorityBoardsListing = "/private/authorities-and-communities/authority-boards/listing",
  remunerationSettingsListing = "/private/hr-management/remuneration-settings-listing",
  hrManagementLeavesLedgerListing = "/private/hr-management/leaves-ledger-listing",
  createTeachersTitle = "/private/academics/teachers-titles/create",
  teachersTitlesListing = "/private/academics/teachers-titles/listing",
  createCourseType = "/private/academics/course-types/create",
  courseTypesListing = "/private/academics/course-types/listing",
  createTeacherCourseType = "/private/academics/teacher-course-types/create",
  teacherCourseTypesListing = "/private/academics/teacher-course-types/listing",
  setHolidaysListing = "/private/hr-management/set-holidays/set-holidays-listing",
  eportalTestingServiceListing = "/private/e-portal/eportal-testing-service-listing",
  activitiesAndEventListing = "/private/academics/activities-and-event/listing",
  activitiesAndEventCreate = "/private/academics/activities-and-event/create",

  //student portal routes
  duplicateStudentCardReq = "/private/student-portal/my-links/create-duplicate-card-request",
  studentPortalDocumentsListing = "/private/student-portal/my-links/student-portal-documents",
  studentPortalProfile = "/private/student-portal/my-links/student-portal-profile",
  studentPortalEditProfile = "/private/student-portal/my-links/edit-profile",
  studentPortalLMS = "/private/student-portal/LMS",
  studentPortalLibraryBooks = "/private/student-portal/library-books-listing",
  studentPortalSupportTickets = "/private/student-portal/support-tickets-listing",
  studentPortalNoticeBoard = "/private/student-portal/notice-board",
  campaignProgramsListing = "/private/admissions/admission-campaigns/programs-listing",
  createSetHolidays = "/private/hr-management/set-holidays/create-set-holidays",
  studentDashboard = "/private/student-portal/student-dashboard",
  studentTimetable = "/private/student-portal/time-table/view-timetable",
  studentPortalSupportTicketsListing = "/private/student-portal/support-tickets/listing",
  createStudentPortalSupportTicket = "/private/student-portal/support-tickets/create",

  studentScholarshipListing = "/private/student-portal/scholarship/listing",
  applyScholarship = "/private/student-portal/scholarship/apply",
  appliedScholarshipListing = "/private/student-portal/scholarship/applied-listing",
  studentScholarshipProfile = "/private/student-portal/scholarship/scholarship-profile-wizard",
  studentSocietyApplicationListing = "/private/student-portal/society-application/listing",
  studentAffairsDashboard = "/private/ds-system/student-affairs-dashboard",

  academicsStudentPlanOfStudies = "/private/academics/academic-student-plan-of-studies/academic-student-plan-of-studies-listing",
  academicsStudentTranscript = "/private/academics/academic-student-transcript/academic-student-transcript-listing",
  academicHolidaysList = "/private/academics/academic-holidays/academic-holidays-listing",
  academicStudentClearance = "/private/academics/academic-student-clearance/academic-student-clearance-listing",
  studentLMSMyFiles = "/private/student-portal/LMS/my-files",
  studentAssignments = "/private/student-portal/LMS/assignments",
  studentCourseMaterial = "/private/student-portal/LMS/course-material",
  studentVehicalEntryListing = "/private/student-portal/vehicle-entry/vehicle-entry-listing",
  createStudentVehicleEntry = "/private/student-portal/vehicle-entry/create-vehicle-entry",
  studentTransportScheduleList = "/private/student-portal/transport-schedule/transport-schedule-listing",
  studentSurveyListing = "/private/student-portal/surveys/listing",
  studentAcademicCourseChallan = "/private/academics/academic-course-challan/academic-course-challan-listing",
  courseRepeatRequestListing = "/private/academics/course-repeat-request/course-repeat-request-listing",
  admissionLockedMeritListing = "/private/admissions/admission-locked-merit/admission-locked-merit-Listing",
  admissionReconsiderListing = "/private/admissions/admission-reconsider/admission-reconsider-listing",
  academicProgramSpecializationListing = "/private/academics/program-specialization/program-specialization-listing",
  academicCreateProgramSpecialization = "/private/academics/program-specialization/create-program-specialization",
  academicManageSpecializationListing = "/private/academics/program-specialization/manage-specialization-listing",
  academicCreateManageSpecialization = "/private/academics/program-specialization/create-manage-specialization",
  academicManageStudentListing = "/private/academics/program-specialization/manage-student-listing",
  academicCreateManageStudent = "/private/academics/program-specialization/create-manage-student",
  academicAppliedSpecialization = "/private/academics/program-specialization/applied-specialization-listing",
  organizationAdminListing = "/private/organization/admin-management/admin-listing",
  createOrganizationAdmin = "/private/organization/admin-management/create-admin",
  updateOrganizationAdmin = "/private/organization/update-organization",
  assessmentCategoriesListing = "/private/academics/assessment-categories/listing",
  createAssessmentCategory = "/private/academics/assessment-categories/create",
  assessmentActivitiesListing = "/private/academics/assessment-activities/listing",
  createAssessmentActivity = "/private/academics/assessment-activities/create",
  resultSettingTemplateListing = "/private/academics/result-setting-template-management/result-setting-template-listing",
  createResultSettingTemplateListing = "/private/academics/result-setting-template-management/create-result-setting-template",
  templateHeaderListing = "/private/academics/template-header-management/template-header-listing",
  createTemplateHeader = "/private/academics/template-header-management/create-template-header",
  orgAdminListing = "/private/organization/org-admin-management/org-admin-listing",
  admissionDashboard = "/private/ds-system/admission-dashboard",
  referralsDashboard = "/private/ds-system/referrals-dashboard",
  scholarshipDashboard = "/private/ds-system/scholarship-dashboard",

  agencyDashboard = "/private/ds-system/agency-dashboard",

  nonDegreeProgramsDashboard = "/private/ds-system/non-degree-programs-dashboard",
  careerDashboard = "/private/ds-system/career-dashboard",
  enrollmentDashboard = "/private/ds-system/enrollment-dashboard",
  editEPStudentProfile = "/private/e-portal/profile-management/edit-profile",
  viewEPStudentProfile = "/private/e-portal/profile-management/view-profile",
  addStudentsToPlanOfStudy = "/private/academics/plan-of-study/add-students",
  emailTemplateCreate = "/private/email-template/create",
  emailTemplateListing = "/private/email-template/listing",
  emailTemplateKeyCreate = "/private/email-template/keys/create",
  emailTemplateKeyListing = "/private/email-template/keys/listing",
  timeTableCreate = "/private/time-table/create",
  timeTableListing = "/private/time-table/listing",
  viewTimeTable = "/private/time-table/view-timetable",
  timeTablePlannerCreate = "/private/time-table/planner/create",
  timeTablePlannerListing = "/private/time-table/planner/listing",
  timeTablePlannerDashboard = "/private/time-table/planner/dashboard",
  shiftProfileListing = "/private/time-table/shift-profile/listing",
  createShiftProfile = "/private/time-table/shift-profile/create",
  roomToSectionProfileListng = "/private/time-table/room-to-section-profile/listing",
  createRoomToSectionProfile = "/private/time-table/room-to-section-profile/create",
  roomToCourseProfileListing = "/private/time-table/room-to-course-profile/listing",
  createRoomToCourseProfile = "/private/time-table/room-to-course-profile/create",
  timeTableYearMapListing = "/private/time-table/time-table-year-map/listing",
  timeTableFetFileGenerator = "/private/time-table/time-table-fet-file-generator/create",
  academicsDashboard = "/private/ds-system/academics-dashboard",
  facultyWorkloadDashboard = "/private/ds-system/faculty-workload-dashboard",
  departmentFacultyList = "/private/ds-system/faculty-workload-dashboard/department-faculty-list",
  defaultCreditHoursListing = "/private/time-table/default-credit-hours/management",
  prefferedRoomCourseListing = "/private/time-table/planner/room-to-course-listing",
  prefferedRoomCourseListCreate = "/private/time-table/planner/create-room-to-course",
  roomToSectionCreate = "/private/time-table/planner/create-room-to-section",
  roomToSectionListing = "/private/time-table/planner/room-to-section-listing",
  myEnrollments = "/private/student-portal/academics/current-enrollments",
  examinationDashboard = "/private/ds-system/examination-dashboard",
  academicProgramAdvisingDashboard = "/private/ds-system/program-advising-dashboard",
  lmsDashboard = "/private/ds-system/lms-dashboard",

  studentPlanOfStudy = "/private/student-portal/academics/plan-of-studies",
  studentTranscript = "/private/student-portal/academics/transcript",
  studentFinancialVouchers = "/private/academics/student-portal-student-voucher/financial-vouchers",
  studentMyWallet = "/private/student-portal/my-wallet",
  studentAccountStatement = "/private/academics/student-portal/account-statement",

  myClearanceListing = "/private/student-portal/academics/my-clearance",
  academicsCurrentEnrollment = "/private/academics/academic-current-enrollment/academic-current-enrollment-listing",
  courseMaterialList = "/private/academics/academic-current-enrollment/enrollments-course-material",
  academicsStudentFeePlan = "/private/academics/academic-fee-plan/academic-fee-plan-listing",

  myFeeVoucher = "/private/student-portal/my-fee-voucher",
  studentHolidayList = "/private/student-portal/holiday-list",
  generateCourseChallan = "/private/student-portal/generate-course-challan",
  ticketListing = "/private/student-portal/ticket-listing",
  createTicket = "/private/student-portal/create-ticket",
  financeStudentVouchersListing = "/private/finance/student-vouchers-listing",
  academicsVerifiedGradebookListing = "/private/academics/verified-gradebook/verified-gradebook-listing",
  academicsAwardList = "/private/academics/award-list/award-listing",

  timeTableDurationListing = "/private/time-table/durations/listing",
  timeTableDurationCreate = "/private/time-table/durations/create",

  timeTableActivityListing = "/private/time-table/activities/listing",
  timeTableActivityCreate = "/private/time-table/activities/create",

  plannerDaysListing = "/private/time-table/planner-days/listing",
  plannerDaysCreate = "/private/time-table/planner-days/create",

  plannerTimeSlotsListing = "/private/time-table/planner-time-slots/listing",
  plannerTimeSlotsCreate = "/private/time-table/planner-time-slots/create",

  // CMS Routes
  newsManagementsListing = "/private/cms/news-management/listing",
  newsManagementsCreate = "/private/cms/news-management/create",

  newsAudienceListing = "/private/cms/news-audience/listing",
  newsAudienceCreate = "/private/cms/news-audience/create",

  newsAndEventsListing = "/private/news-and-events/listing",
  newsAndEventsCreate = "/private/news-and-events/create",
  newsAndEventsView = "/private/news-and-events/view",

  // Communications (Calendar / Events)
  communicationsCalendar = "/private/communications/calendar",
  communicationsCalendarsListing = "/private/communications/calendars/listing",
  communicationsCalendarsCreate = "/private/communications/calendars/create",
  communicationsEventsListing = "/private/communications/events/listing",
  communicationsEventsCreate = "/private/communications/events/create",
  communicationsEventsView = "/private/communications/events/view",
  communicationsNewsListing = "/private/communications/news/listing",
  communicationsNewsCreate = "/private/communications/news/create",
  communicationsAnnouncementsListing = "/private/communications/announcements/listing",
  communicationsAnnouncementsCreate = "/private/communications/announcements/create",
  communicationsNotifications = "/private/communications/notifications",
  communicationsAnalytics = "/private/communications/analytics",

  // Notification routes
  notificationsListing = "/private/organization/notifications/listing",
  notificationsCreate = "/private/organization/notifications/create",
  notificationsView = "/private/organization/notifications/view",
  myNotificationsListing = "/private/my-apps/my-notifications/listing",
  myAppsDeclaredResult = "/private/my-apps/declared-result",
  academicProgramAdvisorsListing = "/private/academics/program-advisors/listing",
  academicAllocatedStudentsListing = "/private/academics/program-advisors/allocated-students",

  // Academics Settings
  academicsSettingsSelfEnrollments = "/private/academics/settings/self-enrollments",
  academicsSettingsCourseRepeatFee = "/private/academics/settings/course-repeat-fee",
  academicsSettingsCourseRepeatPolicy = "/private/academics/settings/course-repeat-policy",
  academicsSettingsCreditHourPolicy = "/private/academics/settings/credit-hour-policy",
  academicsSettingsObe = "/private/academics/settings/obe",
  academicsSettingsAttendancePolicy = "/private/academics/settings/attendance-policy", // Policy for attendance
  academicsSettingsGradePolicy = "/private/academics/settings/grade-policy",
  academicsSettingsStudentMigration = "/private/academics/settings/student-migration",
  academicsObePosCourseClos = "/private/academics/obe-framework/pos-course-clos/:pos_course_id",
  academicTcClos = "/private/academics/obe-framework/tc-clos/:tc_id",
  obeLessonPlanListing = "/private/academics/obe-framework/lesson-plans/listing",
  obeLessonPlanCreate = "/private/academics/obe-framework/lesson-plans/create",
  academicSessionEnrollmentListing = "/private/academics/academic-session-management/enrollment-listing",

  // Transport Module Routes
  vehicleTypesListing = "/private/transport/vehicle-types/listing",
  createVehicleType = "/private/transport/vehicle-types/create",
  vehiclesListing = "/private/transport/vehicles/listing",
  createVehicle = "/private/transport/vehicles/create",
  transportStaffListing = "/private/transport/staff/listing",
  createTransportStaff = "/private/transport/staff/create",
  stopsListing = "/private/transport/stops/listing",
  createStop = "/private/transport/stops/create",
  routesListing = "/private/transport/routes/listing",
  createRoute = "/private/transport/routes/create",
  subRoutesListing = "/private/transport/sub-routes/listing",
  createSubRoute = "/private/transport/sub-routes/create",
  transportAssignmentsListing = "/private/transport/assignments/listing",
  createTransportAssignment = "/private/transport/assignments/create",
  subRoutesManageStops = "/private/transport/sub-routes/manage-stops",
  academicMarkAttendance = "/private/academics/manage-academic-sessions/mark-attendance",
  academicMarkGroupAttendance = "/private/academics/manage-academic-sessions/mark-group-attendance",
  studentScanAttendance = "/private/student-portal/academics/scan-attendance",
  studentMyAttendance = "/private/student-portal/academics/my-attendance",
  timeTableLectureAttendance = "/private/time-table/lecture-attendance",

  // SIR Routes
  sirDashboard = "/private/my-apps/sir/dashboard",
  sirInitiate = "/private/my-apps/sir/initiate",
  sirActionRequired = "/private/my-apps/sir/action-required",
  sirTracking = "/private/my-apps/sir/tracking/:id",

  // SIR Setup
  sirCategoryListing = "/private/my-apps/sir/setup/categories",
  sirCategoryCreate = "/private/my-apps/sir/setup/categories/create",
  sirTypeListing = "/private/my-apps/sir/setup/types",
  sirTypeCreate = "/private/my-apps/sir/setup/types/create",
  sirTypeFieldsListing = "/private/my-apps/sir/setup/types/:type_id/fields",
  sirTypeFieldsCreate = "/private/my-apps/sir/setup/types/:type_id/fields/create",

  // Student Affairs Module Routes
  tenureListing = "/private/student-affairs/tenure/listing",
  createTenure = "/private/student-affairs/tenure/create",
  levelListing = "/private/student-affairs/level/listing",
  createLevel = "/private/student-affairs/level/create",
  memberTypeListing = "/private/student-affairs/member-type/listing",
  createMemberType = "/private/student-affairs/member-type/create",
  skillListing = "/private/student-affairs/skill/listing",
  createSkill = "/private/student-affairs/skill/create",
  societyListing = "/private/student-affairs/society/listing",
  createSociety = "/private/student-affairs/society/create",
  appStatusListing = "/private/student-affairs/app-status/listing",
  createAppStatus = "/private/student-affairs/app-status/create",
  bodyListing = "/private/student-affairs/body/listing",
  createBody = "/private/student-affairs/body/create",
  eventTypeListing = "/private/student-affairs/event-type/listing",
  createEventType = "/private/student-affairs/event-type/create",
  eventVenueListing = "/private/student-affairs/event-venue/listing",
  createEventVenue = "/private/student-affairs/event-venue/create",
  eventOrganizerListing = "/private/student-affairs/event-organizer/listing",
  createEventOrganizer = "/private/student-affairs/event-organizer/create",
  eventFundingListing = "/private/student-affairs/event-funding/listing",
  createEventFunding = "/private/student-affairs/event-funding/create",
  competitionTypeListing = "/private/student-affairs/competition-type/listing",
  createCompetitionType = "/private/student-affairs/competition-type/create",
  competitionLevelListing = "/private/student-affairs/competition-level/listing",
  createCompetitionLevel = "/private/student-affairs/competition-level/create",
  externalParticipantListing = "/private/student-affairs/external-participant/listing",
  createExternalParticipant = "/private/student-affairs/external-participant/create",
  societyEventListing = "/private/student-affairs/society-event/listing",
  createSocietyEvent = "/private/student-affairs/society-event/create",
  myAppsOdRequestsListing = "/private/my-apps/od-requests/listing",
  myAppsOdRequestsCreate = "/private/my-apps/od-requests/create",

  // APER
  aperDashboard = "/private/aper/dashboard",
  aperAttributesListing = "/private/aper/assessment-attributes/listing",
  aperAttributesCreate = "/private/aper/assessment-attributes/create",
  aperGradingsListing = "/private/aper/assessment-gradings/listing",
  aperGradingsCreate = "/private/aper/assessment-gradings/create",
  aperSettings = "/private/aper/settings",
  aperReportsListing = "/private/aper/reports/listing",
  aperReportsCreate = "/private/aper/reports/create",
  aperReportsView = "/private/aper/reports/view/:id",
  aperReportsEvaluate = "/private/aper/reports/evaluate/:id",

  // Training and Development Program
  tdpListing = "/private/qec/training-development/programs",
  createtdpProgram = "/private/qec/training-development/programs/create",
  edittdpProgram = "/private/qec/training-development/programs/edit/:id",
  tdpNominations = "/private/qec/training-development/nominations",
  mytdps = "/private/my-apps/training-development/my-tdps",
  tdpAttendanceScan = "/private/my-apps/training-development/attendance-scan",
  tdpAttendanceListing = "/private/qec/training-development/attendance",
  tdpAttendanceListingMarkAttendance = "/private/qec/training-development/attendance/mark",
  tdpCategories = "/private/qec/training-development/categories",
  tdpTrainers = "/private/qec/training-development/trainers",
  tdpFeedbackForms = "/private/qec/training-development/feedback-forms/listing",
  tdpFeedbackResponses = "/private/qec/training-development/feedback-forms/responses/:id",
  createtdpTrainer = "/private/qec/training-development/trainers/create",
  edittdpTrainer = "/private/qec/training-development/trainers/edit/:id",
  tdpDashboard = "/private/qec/training-development/dashboard",
  tdpCertificates = "/private/qec/training-development/programs/:id/certificates",
  tdpTrainerCertificates = "/private/qec/training-development/programs/:id/trainer-certificates",
  tdpProgramsListing = "/private/qec/training-development/programs",
  tdpNominatedListing = "/private/qec/training-development/nominated-employees",
  tdpSessionsListing = "/private/qec/training-development/sessions-listing",

  aperTypesListing = "/private/aper/types/listing",
  aperTypesCreate = "/private/aper/types/create",
  aperAppraisalsListing = "/private/aper/appraisals/listing",
  aperAppraisalsCreate = "/private/aper/appraisals/create",
  aperAppraisalsEmployees = "/private/aper/appraisals/employees/:id",
  myAppraisal = "/private/my-apps/my-appraisal",
  myAppraisalCreate = "/private/my-apps/my-appraisal/create",
  myAppraisalFacultyCreate = "/private/my-apps/my-appraisal/faculty-form/new",
  medicalInsuranceFormListing = "/private/my-apps/medical-insurance-form/listing",
  medicalInsuranceFormCreate = "/private/my-apps/medical-insurance-form/create",
  medicalInsuranceFormEdit = "/private/my-apps/medical-insurance-form/edit/:id",
}

